import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';
import { fillTemplateWithData } from '../../routines';

@Component({
    selector: 'se-iframe-call',
    templateUrl: './iframe-call.component.html',
    styleUrls: ['../call-style/call.scss'],
})
export class IframeCallComponent extends AbstractCallComponent implements OnInit, AfterViewInit {
    url: SafeResourceUrl | null = null;

    constructor(private domSanitizer: DomSanitizer) {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        const url = this.parseUrlWithData();
        this.url = url ? this.domSanitizer.bypassSecurityTrustResourceUrl(url) : null;
    }

    parseUrlWithData = (): string => {
        if (!this.call.url) return '';
        if (this.dataStore) {
            return fillTemplateWithData(this.dataStore, this.call.placeholders, this.call.url);
        } else {
            return this.call.url;
        }
    };

    ngAfterViewInit(): void {
        if (this.url) this.showLoading = true;
    }

    close(): void {
        this.end();
    }

    onLoad() {
        this.showLoading = false;
    }
}
